// issueReport.js

import { baseURL } from 'utils/api'
import Dictionary from '../dictionary'
import axios from 'axios'

const { issueReport } = Dictionary

const issueReportServies = {
  view: async (paramsObj) => {
    return axios.get(baseURL + issueReport.create(),{params: paramsObj})
  },
  add: async (data) => {
    return axios.post(baseURL + issueReport.create(), data)
  },
  delete: async (id) => {
    return axios.delete(baseURL + issueReport.getById(id))
  },
  edit: async (id, data) => {
    return axios.put(baseURL + issueReport.getById(id), data)
  }, 
  updateById: async (id, data) => {
    return axios.put(baseURL + issueReport.updateById(id), data)
  },
  comment: async (id, data) => {
    return axios.put(baseURL + issueReport.updateById(id), data)
  },
  getDetailById: async (id) => {
    return axios.get(baseURL + issueReport.getById(id))
  },
    getIssueDetailID: async (id) => {
    return axios.get(baseURL + issueReport.getIssueDetailID(id))
  },
}
export default issueReportServies